module.exports = __webpack_public_path__ + "img/planet.776115eb.png";